import { render, staticRenderFns } from "./addWx.vue?vue&type=template&id=78fe4cff&scoped=true"
import script from "./addWx.vue?vue&type=script&lang=js"
export * from "./addWx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe4cff",
  null
  
)

export default component.exports